// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { PatientPortalAuthenticationRequest } from './patient-portal-authentication-request';

/** See com.rev360.pms.api.controller.patient.patientportaluser.PatientPortalAuthenticationFormRequest */
/* istanbul ignore next */
@GandalfModel
export class PatientPortalAuthenticationFormRequest extends PatientPortalAuthenticationRequest {

	@GandalfLabel('Allow Login')
	@GandalfValidator({ notNull: { message: 'Allow Login is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	allowLogin!: boolean;

	@GandalfLabel('Authorized Patients')
	@GandalfValidator({ notNull: { message: 'Authorized Patients is required' } })
	@GandalfArray(Number)
	authorizedPatientIds!: number[];

	@GandalfLabel('Patient')
	@GandalfValidator({ notNull: { message: 'Patient is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientId!: number;

	@GandalfLabel('Temporary Password')
	@GandalfValidator({ sizeString: { message: 'Temporary Password cannot be longer than 128 characters', minLength: 0, maxLength: 128 } })
	@GandalfProperty({ designType: String })
	temporaryPassword!: string | null;

	@GandalfLabel('Username')
	@GandalfValidator({ sizeString: { message: 'Username cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	userName!: string | null;

}
